module.exports = __webpack_public_path__ + "static/img/testimony10.8a9ac89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/testimony10.png
// module id = T6Eh
// module chunks = 1 3